import React, { useEffect } from 'react';

import { RadioGroupOption, Grid, RadioGroup } from '@gogame/components';
import { withFormField, FormFieldArray } from '@gogame/form';
import { AmountFormatter } from '@gogame/intl-ts';

import { AMOUNT } from 'scenes/IO/components/IOForm/constants';

import MonthAmount from './MonthAmount';
import MonthlyTotal from './MonthlyTotal';

const periodsEqual = (periodA, periodB) => {
  return periodA.every((d, i) => d === periodB[i]);
};

const rangesEqual = (rangeA = [], rangeB = []) => {
  if (rangeA?.length !== rangeB?.length) {
    return false;
  }
  return rangeA.every(({ period }, i) =>
    periodsEqual(period, rangeB[i].period)
  );
};

const MonthlyBudget = ({
  area,
  form,
  name,
  value = [],
  averageMonthlyAmount,
  budgetAmount,
  disabled,
  currency,
}) => {
  if (value === null) {
    value = [];
  }
  const handleChangeType = (_e, value) => {
    form.setFieldValue(name, value ? area.data : []);
  };

  useEffect(() => {
    if (area.data && value?.length && !rangesEqual(value, area.data)) {
      form.setFieldValue(name, area.data);
    }
  }, [area.data]);

  return (
    <RadioGroup
      value={!!value?.length}
      onChange={handleChangeType}
      vertical={true}
      title={'Monthly Budget'}
      padding={'0'}
    >
      <RadioGroupOption
        label={
          <span>
            Same each month{' '}
            {averageMonthlyAmount ? (
              <AmountFormatter {...averageMonthlyAmount} />
            ) : null}
          </span>
        }
        value={false}
        disabled={disabled}
      />

      {/*{averageMonthlyAmount ? (*/}
      {/*  <LegacyText style={{ margin: '0 0 12px 36px' }}>*/}
      {/*    <AmountFormatter {...averageMonthlyAmount} />*/}
      {/*  </LegacyText>*/}
      {/*) : null}*/}

      <RadioGroupOption
        label={'Customized per month'}
        value={true}
        disabled={disabled}
      />

      {value.length ? (
        <Grid container>
          <FormFieldArray name={name}>
            {() => {
              return value.map(({ period }, i) => (
                <MonthAmount
                  key={i}
                  date={period[0]}
                  debounceTimeout={300}
                  name={`${name}[${i}].${AMOUNT}`}
                  currency={currency}
                />
              ));
            }}
          </FormFieldArray>
          <MonthlyTotal
            monthly={value}
            budgetAmount={budgetAmount}
            currency={currency}
          />
        </Grid>
      ) : null}
    </RadioGroup>
  );
};

export default withFormField({ padding: '16px 8px' })(MonthlyBudget);
